<div class="header">
  <div>
    총
    <span class="number">{{ _showMine ? _myMemoCount : _totalMemoCount }}</span
    >개의 전체 메모
  </div>
  <sui-checkbox type="boxFirst" *ngIf="_canShowMine">
    내 메모만 보기
    <input type="checkbox" [(ngModel)]="_showMine" />
  </sui-checkbox>
</div>
<div
  class="body"
  #bodyContainer
  [class.show-mine]="_showMine"
  [class.no-mine-memos]="_showMine && _myMemoCount === 0 && _memoGroups"
  suiListIntersectionObserver
>
  <div
    *ngIf="_showMine && _myMemoCount === 0 && _memoGroups"
    class="no-mine-memos"
    style="text-align: center; padding: 20px; color: #282828; font-size: 12px"
  >
    내 메모가 없습니다
  </div>

  <ng-container *ngFor="let iid of _pageIids; index as itemIndex">
    <div
      class="group {{ group.type }}"
      #group
      [class.is-active]="
        groupIndex === _activeGroupIndex && iid === _currentIid
      "
      *ngFor="let group of _memoGroups?.[itemIndex]; index as groupIndex"
      (click)="_onGroupClick(itemIndex, groupIndex)"
    >
      <div class="text">{{ group.text }}</div>
      <ng-container *ngIf="_isCommentaryEditorMode">
        <viewer-commentary-editor-memo
          class="mine memo-comp"
          *ngFor="let memo of group.memos"
          [memo]="memo"
          [text]="memo.text"
          (memoDeleted)="_onMemoDeleted(itemIndex, groupIndex)"
        ></viewer-commentary-editor-memo>
      </ng-container>
      <ng-container *ngIf="!_isCommentaryEditorMode">
        <viewer-reading-mode-memo
          class="{{ memo.is_mine ? 'mine' : 'others' }} memo-comp"
          *ngFor="let memo of group.memos"
          [memo]="memo"
          [text]="memo.text"
          (memoDeleted)="_onMemoDeleted(itemIndex, groupIndex)"
          (memoBlinded)="_onMemoBlinded(memo)"
          (memoUserBlocked)="_onMemoUserBlocked(memo)"
          (memoSeeDetailsButtonClicked)="_onMemoSeeDetailsButtonClicked()"
          (memoPinOptionChanged)="_onMemoPinOptionChanged()"
          [isAuthorOnline]="_onlineUserMap[memo.author.id]"
          suiListItemIntersectionObserver
          (intersected)="_onMemoRead(memo)"
          [stopAfterIntersection]="true"
        ></viewer-reading-mode-memo>
      </ng-container>
      <div class="divider"></div>
    </div>
  </ng-container>
</div>
